export default __webpack_public_path__ + "static/media/yt-logo2.b77633df.png";